import {Card, Stack, Table, Title} from '@mantine/core';
import {Pipeline} from '../types';

export const PipelineStagesPanel = ({record}: { record: Pipeline }) => {

    if (!record.stages || record.stages.length === 0) {
        return null;
    }

    return (
        <Card withBorder padding='md' radius='md'>
            <Stack gap={'sm'}>
                <Title order={5}>Pipeline Stages</Title>
                <Table striped highlightOnHover withTableBorder>
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Th>Name</Table.Th>
                            <Table.Th>Order</Table.Th>
                            <Table.Th>Build Provider</Table.Th>
                            <Table.Th>Deploy Provider</Table.Th>
                            <Table.Th>Region</Table.Th>
                            <Table.Th>Requires Approval</Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {record.stages.map((stage, index) => (
                            <Table.Tr key={index}>
                                <Table.Td>{stage.name}</Table.Td>
                                <Table.Td>{stage.order}</Table.Td>
                                <Table.Td>{stage.buildProvider || 'n/a'}</Table.Td>
                                <Table.Td>{stage.deployProvider || 'n/a'}</Table.Td>
                                <Table.Td>{stage.region || 'us-west-2'}</Table.Td>
                                <Table.Td>{stage.requiresApproval ? 'Yes' : 'No'}</Table.Td>
                            </Table.Tr>
                        ))}
                    </Table.Tbody>
                </Table>
            </Stack>
        </Card>
    );
};
